<!-- Adicione aqui o template para busca de vendas -->
<p-toast></p-toast>
<div class="mx-auto p-8 bg-white rounded-lg shadow-sm flex flex-col space-y-4">
  <div class="flex-1 p-4 bg-white rounded-lg shadow-sm">
    <h1 class="text-xl font-semibold">Buscar pedido ou orçamento</h1>
    <div class="flex flex-wrap gap-4 items-center mb-4">
      <div class="flex flex-col">
        <label for="busca" class="block text-sm font-medium text-gray-700">Buscar por Cliente, Vendedor ou ID</label>
        <input
          type="text"
          id="busca"
          [(ngModel)]="termoBusca"
          (keyup.enter)="buscarVendas()"
          placeholder="Digite nome do cliente, vendedor ou ID da venda"
          class="mt-1 block w-full md:w-80 p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="flex items-end">
        <button
          (click)="buscarVendas()"
          class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Buscar
        </button>
      </div>
    </div>
    <div class="w-full space-y-4">
      <p-table [value]="vendas" class="w-full mt-6">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-2 border-b text-left">Id</th>
            <th class="p-2 border-b text-left">Cliente</th>
            <th class="p-2 border-b text-left">VendaSituacao</th>
            <th class="p-2 border-b text-left">Usuário</th>
            <th class="p-2 border-b text-left">Vendedor</th>
            <th class="p-2 border-b text-left">Valor Total</th>
            <th class="p-2 border-b text-left">Pagamento</th>
            <th class="p-2 border-b text-left">Data Cadastro</th>
            <th class="p-2 border-b text-left">Data Última Modificação</th>
            <th class="p-2 border-b text-center">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-venda>
          <tr>
            <td class="p-2 border-b">{{ venda.id }}</td>
            <td class="p-2 border-b">{{ venda.cliente.nome }}</td>
            <td class="p-2 border-b">
              <span
                [ngClass]="{
                  'inline-block px-2 py-1 rounded text-sm font-semibold': true,
                  'bg-red-100 text-red-800 border border-red-200': venda.vendaSituacao === 'CANCELADA' || venda.vendaSituacao === 'CANCELADO',
                  'bg-green-100 text-green-800 border border-green-200': venda.vendaSituacao === 'FINALIZADA' || venda.vendaSituacao === 'FECHADA' || venda.vendaSituacao === 'CONCLUIDA',
                  'bg-yellow-100 text-yellow-800 border border-yellow-200': venda.vendaSituacao === 'PENDENTE' || venda.vendaSituacao === 'ABERTA'
                }"
              >
                {{ venda.vendaSituacao || '-' }}
              </span>
            </td>
            <td class="p-2 border-b">{{ venda.usuario.username }}</td>
            <td class="p-2 border-b">{{ venda.vendedor.nome.split(' ')[0] }}</td>
            <td class="p-2 border-b">{{ venda.valorTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
            <td class="p-2 border-b">{{ venda.pagamento }}</td>
            <td class="p-2 border-b">{{ venda.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}</td>
            <td class="p-2 border-b">{{ venda.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}</td>
            <td class="p-2 border-b text-center">
              <button class="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600" (click)="editarVenda(venda)">Editar</button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Formulário de edição -->
    <div *ngIf="vendaEditando" class="mt-8 p-4 bg-gray-50 rounded shadow border border-gray-300">
      <h2 class="text-lg font-semibold mb-4">Editar pedido #{{ vendaEditando.id }}</h2>
      <form (ngSubmit)="salvarEdicao()" #formEdit="ngForm">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-fr">

          <!-- Cliente -->
          <div>
            <label class="block text-sm font-medium">Cliente</label>
            <p-dropdown
              [options]="clientes"
              [(ngModel)]="vendaEditando.cliente"
              name="cliente"
              optionLabel="nome"
              placeholder="Selecione o cliente"
              [showClear]="true"
              [filter]="true"
              class="w-full mt-1"
            ></p-dropdown>
          </div>

          <!-- Vendedor -->
          <div>
            <label class="block text-sm font-medium">Vendedor</label>
            <p-dropdown
              [options]="vendedores"
              [(ngModel)]="vendaEditando.vendedor"
              name="vendedor"
              optionLabel="nome"
              placeholder="Selecione o vendedor"
              [showClear]="true"
              [filter]="true"
              class="w-full mt-1"
            ></p-dropdown>
          </div>

          <!-- 🔥 Observação grande (direita ocupando 2x2) -->
          <div class="md:col-span-2 md:row-span-2">
            <label class="block text-sm font-medium">Observação</label>
            <textarea
              class="form-textarea mt-1 block w-full resize-none border border-gray-300 rounded min-h-[60px] max-h-[120px]"
              [(ngModel)]="vendaEditando.observacao"
              name="observacao"
              rows="5"
            ></textarea>
          </div>

          <!-- Pagamento -->
          <div class="col-span-1/2">
            <label class="block text-sm font-medium">Pagamento</label>
            <p-dropdown
              [options]="pagamentosOptions"
              [(ngModel)]="vendaEditando.pagamento"
              name="pagamento"
              placeholder="Selecione o pagamento"
              [showClear]="true"
              class="w-full mt-1"
            ></p-dropdown>
          </div>

          <div class="col-span-1/2">
            <label class="mb-1 font-medium text-gray-700">Status da Venda</label>
            <div class="flex flex-wrap gap-4 mt-2">
              <label *ngFor="let status of statusOptions" class="flex items-center space-x-2">
                <input type="radio" name="vendaSituacao" [value]="status.value" [(ngModel)]="vendaEditando.vendaSituacao" class="h-4 w-4" />
                <span>{{ status.label }}</span>
              </label>
            </div>
          </div>


          <!-- Botões -->
          <div class="mt-4 flex gap-2">
            <button type="submit" class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
              Salvar
            </button>
            <button type="button" class="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500" (click)="cancelarEdicao()">
              Cancelar
            </button>
          </div>
        </div>

      </form>

      <!-- Itens da venda -->
      <div class="mt-8">
        <h3 class="text-md font-semibold mb-2">Itens do pedido</h3>
        <form class="mb-4 flex flex-wrap gap-4 items-center" (ngSubmit)="addItemVenda()" #formItem="ngForm">
          <div class="flex flex-col">
            <label for="produto" class="block text-xs font-medium text-gray-700">Produto</label>
            <p-dropdown
              [options]="produtos"
              [(ngModel)]="novoItem.produto"
              name="produto"
              optionLabel="nome"
              placeholder="Selecione o produto"
              [showClear]="true"
              [filter]="true"
              class="p-2 border rounded-md w-80"
              [required]="true"
            ></p-dropdown>
          </div>

          <div class="flex flex-col">
            <label for="quantidade" class="block text-xs font-medium text-gray-700">Qtd</label>
            <input type="number" [(ngModel)]="novoItem.quantidade" name="quantidade" placeholder="Qtd" class="p-2 border rounded-md w-16" min="1" required />
          </div>


          <div class="flex flex-col">
            <label for="valorDesconto" class="block text-xs font-medium text-gray-700">Desconto</label>
            <input type="number" [(ngModel)]="novoItem.valorDesconto" name="valorDesconto" placeholder="Desconto" class="p-2 border rounded-md w-24" min="0" step="0.01" />
          </div>

          <div class="flex flex-col">
            <label for="valorAcrescimo" class="block text-xs font-medium text-gray-700">Acréscimo</label>
            <input type="number" [(ngModel)]="novoItem.valorAcrescimo" name="valorAcrescimo" placeholder="Acréscimo" class="p-2 border rounded-md w-24" min="0" step="0.01" />
          </div>

          <div class="flex items-end">
            <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Adicionar</button>
          </div>
        </form>

        <!-- Tabela de itens da venda -->
        <div class="bg-white rounded-lg shadow p-4 mt-4">
          <h4 class="text-md font-semibold mb-2">Lista de Itens</h4>
          <p-table [value]="vendaEditando.itens" class="w-full mt-2">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-2 border-b text-left">Id</th>
                <th class="p-2 border-b text-left">Produto</th>
                <th class="p-2 border-b text-left">Qtd</th>
                <th class="p-2 border-b text-left">Preço</th>
                <th class="p-2 border-b text-left">Desconto</th>
                <th class="p-2 border-b text-left">Acréscimo</th>
                <th class="p-2 border-b text-left">Total</th>
                <th class="p-2 border-b text-center">Ações</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-itemVenda let-i="rowIndex">
              <tr>
                <td class="p-2 border-b">{{ itemVenda.produto.id }}</td>
                <td class="p-2 border-b">{{ itemVenda.produto.nome }}</td>
                <td class="p-2 border-b">{{ itemVenda.quantidade }}</td>
                <td class="p-2 border-b">{{ itemVenda.produto.preco | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
                <td class="p-2 border-b">{{ itemVenda.valorDesconto | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
                <td class="p-2 border-b">{{ itemVenda.valorAcrescimo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
                <td class="p-2 border-b">{{ itemVenda.valorTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
                <td class="p-2 border-b text-center">
                  <button type="button" class="text-red-600 hover:text-red-800" (click)="removerItemVenda(i)" title="Remover">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
